import KeycloakService from "../../../config/keycloak";
import {changeLanguage} from "../../../config/tolgee";
import Flag from 'react-world-flags';
import {T} from "@tolgee/react";
import {ExitToApp} from "@mui/icons-material";

export const drawerWidth = 240;

export const languageMenuItems = [
    {
        text: "English",
        icon: <Flag code="GB" style={{width: "28px", height: "28px", marginRight: "0.25em"}} alt="Great Britain" />,
        handleOnClick: () => changeLanguage("en")
    },
    {
        text: "Italiano",
        icon: <Flag code="IT" style={{width: "28px", height: "28px", marginRight: "0.25em"}} alt="Italy" />,
        handleOnClick: () => changeLanguage("it")
    }
]

export const profileMenuItems = [
    {
        text: <T keyName={"text-logout"} defaultValue={"Logout"}/>,
        icon: <ExitToApp sx={{
            marginRight: '0.6em',
            rotate: '180deg',
        }} />,
        handleOnClick: () => KeycloakService.doLogout()
    }
];